// Real photos provided by the salon (Carpe Diem Hair Style by Anna)
const A = "https://customer-assets-4nw71qhi.emergentagent.net/job_barber-portfolio-29/artifacts";

export const GALLERY = [
  { src: `${A}/silyklg7_WhatsApp%20Image%202026-07-25%20at%2022.22.09%20%281%29.jpeg`, tall: true },
  { src: `${A}/mpjg0c81_WhatsApp%20Image%202026-07-25%20at%2022.20.06%20%281%29.jpeg`, tall: false },
  { src: `${A}/japteyjw_WhatsApp%20Image%202026-07-25%20at%2022.22.09.jpeg`, tall: true },
  { src: `${A}/0u8ajphq_WhatsApp%20Image%202026-07-25%20at%2022.20.06%20%282%29.jpeg`, tall: false },
  { src: `${A}/2zvp4zjr_WhatsApp%20Image%202026-07-25%20at%2022.22.09%20%282%29.jpeg`, tall: true },
  { src: `${A}/8su8185q_WhatsApp%20Image%202026-07-25%20at%2022.20.06%20%283%29.jpeg`, tall: false },
  { src: `${A}/u3nnuey9_WhatsApp%20Image%202026-07-25%20at%2022.22.09%20%283%29.jpeg`, tall: true },
  { src: `${A}/xxlad9qx_WhatsApp%20Image%202026-07-25%20at%2022.20.06%20%284%29.jpeg`, tall: false },
  { src: `${A}/2uupayl0_WhatsApp%20Image%202026-07-25%20at%2022.20.06.webp`, tall: true },
];

// A striking image used inside the hero portrait frame
export const HERO_IMG = `${A}/2uupayl0_WhatsApp%20Image%202026-07-25%20at%2022.20.06.webp`;
export const ABOUT_IMG = `${A}/japteyjw_WhatsApp%20Image%202026-07-25%20at%2022.22.09.jpeg`;

export const CONTACT = {
  brand: "Carpe Diem",
  sub: "Hair Style by Anna",
  address: "Via Monte Santo, 11 — 34070 Villesse (GO)",
  phoneDisplay: "+39 0481 918155",
  phoneHref: "tel:+390481918155",
  whatsappDisplay: "+39 347 546 7906",
  whatsappHref: "https://wa.me/393475467906",
  mapEmbed:
    "https://www.google.com/maps?q=Via%20Monte%20Santo%2011%2C%2034070%20Villesse%20GO&output=embed",
  mapLink: "https://maps.app.goo.gl/fYk4yn9mUSG4TeGf7",
  instagram: "https://www.instagram.com/carpediem.villesse/",
  facebook: "https://www.facebook.com/CarpeDiemHairstyleByAnna/",
};
